import { ApiService, useAuthStore } from '@supply-mover-2-0/core';

import { RINGCENTRAL_STATE_KEY } from '../oauth-callback.constants';
import type {
	OAuthCallbackParams,
	OAuthCallbackResult,
	OAuthHandler,
} from '../oauth-callback.types';

export const RingCentralOAuthHandler: OAuthHandler = {
	name: 'ringcentral',

	canHandle(params: OAuthCallbackParams): boolean {
		const { code, state } = params;

		if (code == null || state == null) {
			return false;
		}

		if (state.startsWith('ringcentral-user:')) {
			return true;
		}

		const storedState = useAuthStore.getState().ringcentralOAuthState;

		return storedState === state;
	},

	async handle(params: OAuthCallbackParams): Promise<OAuthCallbackResult> {
		const { code, state } = params;

		if (code == null || state == null) {
			return {
				success: false,
				error: 'Missing authorization code or state',
			};
		}

		const isUserFlow = state.startsWith('ringcentral-user:');

		if (isUserFlow) {
			try {
				await ApiService.apiPost(
					'/integrations/ringcentral/user/auth/callback',
					{
						code,
						state,
					},
				);

				return {
					success: true,
					closePopup: true,
					postMessage: {
						type: 'ringcentral_user_oauth_callback',
						success: true,
					},
				};
			} catch (err) {
				console.error('Error handling user RingCentral callback:', err);

				return {
					success: false,
					closePopup: true,
					postMessage: {
						type: 'ringcentral_user_oauth_callback',
						success: false,
					},
				};
			}
		}

		try {
			await ApiService.apiPost('/integrations/ringcentral/auth/callback', {
				code,
				state,
			});

			useAuthStore.getState().setRingcentralOAuthState(null);

			return {
				success: true,
				redirectTo: '/settings/integrations',
			};
		} catch (err) {
			console.error('Error handling RingCentral callback:', err);

			return {
				success: false,
				error: 'Failed to connect RingCentral. Please try again.',
			};
		}
	},

	getStorageKey(): string {
		return RINGCENTRAL_STATE_KEY;
	},
};
